// extracted by mini-css-extract-plugin
module.exports = {"voting-button":"VotingButton_voting-button__Dcals","gradient-layer":"VotingButton_gradient-layer__sxjd3","opacity-layer":"VotingButton_opacity-layer__6WihT"};